import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalUserPage from '../../../../../../stores/global-user-page';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';
import { UserSummaryType } from '../../../../../../api/types/user/user-summary.type';

export const updateInstallmentPlanBankAccountDetailsBankTransferOperation =
  async (
    user: UserSummaryType,
    installmentPlanId: number,
    payload: {
      bankNumber: string;
      branchNumber: string;
      accountNumber: string;
    },
    setLoading: (loading: boolean) => void,
    onSuccess?: () => void,
  ): Promise<boolean> => {
    try {
      setLoading(true);

      const res =
        await appApi.updateInstallmentPlanBankAccountDetailsBankTransfer(
          user.id,
          installmentPlanId,
          payload,
        );

      if (res.data.errCode) {
        toast.warn(displayErrorText(res.data.errCode));
        setLoading(false);
        return false;
      }

      const updatedUserDetails = await appApi.getUserStudentDetails(user.id);
      globalUserPage.studentDetails = updatedUserDetails.data.body;

      toast.success('פרטי הבנק עודכנו בהצלחה');
      setLoading(false);
      onSuccess?.();
      return true;
    } catch (e) {
      console.error('Error updating bank account details:', e);
      toast.error('שגיאה בעדכון פרטי הבנק');
      setLoading(false);
      return false;
    }
  };
